module.exports = __webpack_public_path__ + "static/media/IMG-5212.9121726b.JPG";